import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { MaintenanceWorkflowCancelSchemaValidationSchema } from "@/features/maintenanceWorkflow/schemas/cancelMaintenanceWorkflow.schema";

interface UseCancelMaintenanceWorkflowProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useCancelMaintenanceWorkflow = ({ id, onSuccess, onError }: UseCancelMaintenanceWorkflowProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, MaintenanceWorkflowCancelSchemaValidationSchema>({
    mutationKey: ['cancelMaintenanceWorkflow', id],
    mutationFn: async (data) => privateAxios.put(`/maintenance/workflows/${id}/cancel`, {
      cancel_reason: data.cancel_reason
    }),
    onSuccess,
    onError,
  });
};

export default useCancelMaintenanceWorkflow;
